import axios from "axios";

export const getToken = () => {
  let token = sessionStorage.getItem("token");
  return token;
};

export const getAxios = () => {
  const token = getToken();
  const tenantCode = sessionStorage.getItem("schoolcode") || "";
  const headers = {
    "Content-Type": "application/json",
    Authorization: `${token}`,
    tenantcode: tenantCode,
  };
  return axios.create({ headers });
};

export const getAxiosMultipart = () => {
  const token = getToken();
  const tenantCode = sessionStorage.getItem("schoolcode") || "";
  const headers = {
    Authorization: `${token}`,
    tenantcode: tenantCode,
  };
  return axios.create({ headers });
};
